import { FC, useState } from 'react';

import { YandexDirectReportType } from 'utils/constants/admin';
import { MagritteNotificationName } from 'utils/constants/notification';
import { fileDownload } from 'utils/fileDownload';

import { Button } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { addMagritteNotification } from 'store/models/notification';
import { useDispatch } from 'store/utils';

const TrlKeys = {
    [YandexDirectReportType.ORD]: 'admin.directReport.ord.download',
    [YandexDirectReportType.REFUND]: 'admin.directReport.refund.download',
};

interface DownloadButtonProps {
    downloadUrl: string;
    reportType: YandexDirectReportType;
}

export const DownloadButton: FC<DownloadButtonProps> = ({ reportType, downloadUrl }) => {
    const [isDownloading, setIsDownloading] = useState(false);

    const trl = useTrls();
    const dispatch = useDispatch();

    const handleDownload = async () => {
        setIsDownloading(true);
        try {
            await fileDownload(downloadUrl);
        } catch (error) {
            dispatch(addMagritteNotification(MagritteNotificationName.ReportDownloadError));
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <Button
            mode={reportType === YandexDirectReportType.ORD ? 'primary' : 'secondary'}
            style="accent"
            size="large"
            onClick={handleDownload}
            loading={isDownloading}
        >
            {trl(TrlKeys[reportType])}
        </Button>
    );
};
